import { render, staticRenderFns } from "./account.vue?vue&type=template&id=519156ae&scoped=true"
import script from "./account.vue?vue&type=script&lang=ts"
export * from "./account.vue?vue&type=script&lang=ts"
import style0 from "./account.vue?vue&type=style&index=0&id=519156ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519156ae",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeaderAccount: require('/usr/src/app/components/HeaderAccount/HeaderAccount.vue').default,Footer: require('/usr/src/app/components/Footer/Footer.vue').default,Modal: require('/usr/src/app/components/Modal/Modal.vue').default})
